import { createSlice } from '@reduxjs/toolkit';

export const documentData = createSlice({
    name: 'documentData',
    initialState: {
        documentInformation: {},
        isReadOnly: false,
        userInformation: {},
        savingData: {
            isSaving: '',
            lastSavedDateTime: "",
            fileSize: 0,
        },
        isDocumentChanged: false,
    },
    reducers: {
        setDocumentInformation(state, action) {
            state.documentInformation = action.payload;
            const searchParams = new URLSearchParams(document.location.search)
            const isReadOnlyQuery = searchParams.get("readOnly")
            if (isReadOnlyQuery == "true" || action.payload.rightType == 1) {
                state.isReadOnly = true;
            }
        },
        setIsReadOnly(state, action) {
            state.isReadOnly = action.payload;
        },
        setUserInformation(state, action) {
            state.userInformation = action.payload;
        },
        setSavingData(state, action) {
            state.savingData = { ...action.payload };
        },
        setIsDocumentChanged(state, action) {
            state.isDocumentChanged = action.payload;
        },
    },
});

export const {
    setDocumentInformation,
    setIsReadOnly,
    setUserInformation,
    setSavingData,
    setIsDocumentChanged,
} = documentData.actions;

export default documentData.reducer;
